import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f3b239f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "content_list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "wl" }
const _hoisted_6 = { class: "content_list_item_name" }
const _hoisted_7 = { class: "sx" }
const _hoisted_8 = { class: "zl" }
const _hoisted_9 = {
  key: 0,
  class: "green"
}
const _hoisted_10 = {
  key: 1,
  class: "yellow"
}
const _hoisted_11 = {
  key: 2,
  class: "red"
}

import { onMounted, ref, reactive, watch } from 'vue'
import { checkAllList, toolingList } from '@/apis/WorkOrderAPI'
// import { findListPageForManual } from '@/apis/agencyAPI'
import { choiceStockPageByTransfer } from '@/apis/ExWarehouse'
import { model } from '@/interface'
import { Attribute } from '@/enum'
import { judgmentPlatform } from "@/utils/utils"
import vSearch from '@/components/common/Search.vue'
import vLableSelection from '@/components/common/LabelSelection.vue'

// 搜索数据接口
interface form extends model {
  total: number,
  smodelLabel: string,
  categoryId: string
}


export default /*#__PURE__*/_defineComponent({
  props: {
  show: {     // 是否显示
    type: Boolean,
    required: true
  },
  transferId: {   // 转库单id
    type: String,
    required: false
  },
  warehouseId: {   // 仓库编码
    type: String,
    required: false
  }
},
  emits: ['close', 'value'],
  setup(__props, { emit }) {

const props = __props

const form = reactive<form>({
  capacity: 50,
  page: 0,
  total: 0,
  smodelLabel: '',
  categoryId: ''
})

// 列表数据
const list: any = ref([]);
const loading = ref(false);
const finished = ref(false);
const refreshing = ref(false)
let isOne = ref<boolean>(true)
// const V = ref(null)
let isOpen = ref<boolean>(true)

const test = () => {
  // const { text }: any = V.value
  form.smodelLabel = ''
  // V.value.text = ''
}

const clickTag = (tag: string): void => {
  form.categoryId = tag
  list.value = []
  finished.value = false
  form.page = 0
  form.total = 0
  onLoad()
}

// 搜索框
const searchInput = (data: any) => {
  console.log(data)
  form.page = 0
  finished.value = false
  list.value = []
  form.smodelLabel = data
  onLoad()
}

// 搜索提交
const submit = (): void => {
  form.page = 0
  finished.value = false
  list.value = []
  onLoad()
}

// 返回上一页带参数
const jump = (item: any, i: number): void => {
  list.value.splice(i, 1)
  emit('value', item, list.value.length)
}

// 获取工单列表数据
const onLoad = async () => {
  // if (isOne.value) await checkAllLists()
  if (!finished.value) {
    loading.value = true;
    form.page = form.page + 1
    choiceStockPageByTransfer({
      capacity: form.capacity,
      page: form.page,
      model: {
        transferId: props.transferId,
        warehouseId: props.warehouseId
      }
    }).then(res => {
      if (refreshing.value) {
        list.value = []
        refreshing.value = false;
      }
      loading.value = false;
      if (res.code === 200 && res.data.records && res.data.records.length !== 0) {
        form.total = res.data.total
        list.value.push(...res.data.records)
      } else {
        finished.value = true;
      }
    }).catch((err: any) => {
      loading.value = false;
      finished.value = true;
      if (refreshing.value) {
        list.value = []
        refreshing.value = false;
      }
    })
  }
}

// 下拉刷新优化页面
const onRefresh = () => {
  finished.value = false;
  form.page = 0
  loading.value = true;
  onLoad()
}

let status = ref<boolean>(false)





// 关闭回调
const close = () => {
  emit('close')
}

watch(() => props.show, (news) => {
  if (!news) {
    test()
  } else {
    if (!isOpen.value) {
      list.value = []
      finished.value = false;
      form.page = 0
      loading.value = true;
      onLoad()
    }
    isOpen.value = false
  }
})

onMounted(() => {
  status.value = judgmentPlatform()
})

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: props.show,
    "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((props.show) = $event)),
    position: "bottom",
    style: { height: '100%' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "close",
          onClick: close
        }, [
          _createVNode(_component_van_icon, {
            name: "arrow-down",
            size: "30",
            color: "#ffffff"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_pull_refresh, {
          modelValue: refreshing.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
          onRefresh: onRefresh
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_list, {
              loading: loading.value,
              "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
              finished: finished.value,
              "finished-text": "没有更多了~",
              onLoad: onLoad
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "content_list_item",
                      key: i,
                      onClick: ($event: any) => (jump(item, i))
                    }, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, _toDisplayString(item.locationName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("span", null, _toDisplayString(item.materialName ? item.materialName : '-') + " | " + _toDisplayString(item.materialCode ? item.materialCode : '-') + " | " + _toDisplayString(item.num) + _toDisplayString(item.umodelName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", null, [
                          (item.qualityType == 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, "合格"))
                            : _createCommentVNode("", true),
                          (item.qualityType == 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "不良"))
                            : _createCommentVNode("", true),
                          (item.qualityType == 2)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, "报废"))
                            : _createCommentVNode("", true),
                          _createTextVNode("  / " + _toDisplayString(item.pmodelName ? item.pmodelName : '-') + " / " + _toDisplayString(item.batch ? item.batch : '-'), 1)
                        ])
                      ])
                    ], 8, _hoisted_4))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["loading", "finished"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})